export var Mandatory;
(function (Mandatory) {
    Mandatory["AsIs"] = "as-is";
    Mandatory["Use"] = "use";
    Mandatory["No"] = "no";
})(Mandatory || (Mandatory = {}));
//# sourceMappingURL=Mandatory.js.map